import { render, staticRenderFns } from "./MixForm.vue?vue&type=template&id=1a65edf3&"
import script from "./MixForm.vue?vue&type=script&lang=js&"
export * from "./MixForm.vue?vue&type=script&lang=js&"
import style0 from "./MixForm.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports